/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBearRight = createReactComponent("outline", "arrow-bear-right", "IconArrowBearRight", [["path", { "d": "M12 3h5v5", "key": "svg-0" }], ["path", { "d": "M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93", "key": "svg-1" }]]);

export { IconArrowBearRight as default };
//# sourceMappingURL=IconArrowBearRight.mjs.map
